//
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProduct'
import ProviderModel from '@/models/Purchase/PchProvider'

//
import ProductFilters from '@/views/Warehouse/WhProduct/partials/ProductFilters'
import ProductHeaders from '@/views/Warehouse/WhProduct/partials/ProductHeaders'
import DetailHeaders from './headersBoleta'
/* models */
import CustomerModel from '@/models/Sale/SlCustomer'
import SlSaleInvoice from '../../models/Sale/SlSaleInvoice'
//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
//
const formatDetail = detail => {
    return detail.map(detail => {
        let newDetail = { ...detail }
        newDetail.name = detail.wh_product.name
        newDetail.internal_code = detail.wh_product.internal_code
        newDetail.global_discount_line_amount = detail.discount_or_charge_value
        newDetail.saldo_subtotal = detail.remaining_amount
        newDetail.update = false
        return newDetail
    })
}
export default (Details) => [
    // {
    //     name: 'invoice_number',
    //     type: 'select',
    //     props: {
    //         //chips: true,
    //         //deletableChips: true,
    //         itemText: 'number',
    //         itemValue: 'id',
    //         items: [],
    //         label: 'N° de factura',
    //         rules: [RequiredRule],
    //         'return-object': true,
    //     },
    //     trigger(ctx) {
    //         console.log(ctx.value.invoice_number, 'invoice')
    //         ctx.value.selected = formatDetail(
    //             ctx.value.invoice_number.sl_detail_sale_invoices
    //         )
    //         ctx.value.selected_iva = ctx.value.invoice_number.iva
    //         ctx.value.selected_total = ctx.value.invoice_number.total
    //         ctx.value.selected_net_subtotal = ctx.value.invoice_number.net_total
            
    //         ctx.value.selected_global_discount_amount = ctx.value.invoice_number
    //             .global_discount_amount
    //             ? ctx.value.invoice_number.global_discount_amount
    //             : 0
    //         ctx.value.selected_new_net_subtotal = ctx.value.invoice_number.net_total + ctx.value.selected_global_discount_amount
    //     },
    // },
    // {
    //     name: 'sale_number',
    //     type: 'combobox',
    //     props: {
    //         chips: true,
    //         deletableChips: true,
    //         itemText: 'number',
    //         itemValue: 'id',
    //         label: 'N° de Boleta',
    //         rules: [],
    //     },
    // },
    // {
    //     name: 'pch_payment_condition_id',
    //     type: 'autocomplete-model',
    //     props: {
    //         label: 'Método de pago',
    //         itemText: 'type',
    //         itemValue: 'id',
    //         model: PaymentConditionModel,
    //         noObject: true,
    //         paramSearch: 'type',
    //     },
    // },
    // {
    //     name: 'authorization_date',
    //     type: 'date-field',
    //     props: {
    //         label: 'Fecha autorización',
    //         pickerProps: {
    //             readonly: true,
    //         },
    //     },
    // },
    // {
    //     name: 'receiving_date',
    //     type: 'date-field',
    //     props: {
    //         label: 'Fecha recepción',
    //         pickerProps: {
    //             readonly: true,
    //         },
    //     },
    // },
    // {
    //     name: 'emission_date',
    //     type: 'date-field',
    //     props: {
    //         label: 'Fecha emisión',
    //         fieldProps: {
    //             rules: [RequiredRule],
    //         },
    //     },
    // },
    // {
    //     name: 'payment_date',
    //     type: 'date-field',
    //     props: {
    //         label: 'Fecha pago',
    //         fieldProps: {
    //             rules: [RequiredRule],
    //         },
    //     },
    // },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            headers: DetailHeaders,
            noDataText: 'Sin detalle.',
            noExport: true,
            pickerProps: {
                filters: ProductFilters,
                headers: ProductHeaders,
                mapper: row => {
                    //
                    row.quantity = 0
                    row.net_price = 0
                    row.global_discount_line_amount = 0
                    row.net_total = 0
                    row.stock_return = false
                    //
                    return row
                },
                items: Details,
                //service: ProductModel,
            },
            showNativePagination: true,
            toolbarTitle: 'Detalle Documento',
        },
    },
    // {
    //     name: 'acc_cost_center_id',
    //     type: 'autocomplete-model',
    //     props: {
    //         label: 'Centro costo',
    //         itemText: 'name',
    //         itemValue: 'id',
    //         model: CostCenterModel,
    //         noDataText: 'No se encontraron centros de costo.',
    //         noObject: true,
    //         paramSearch: 'name',
    //         //rules: [RequiredRule],
    //     },
    // },
    // {
    //     name: 'is_exent',
    //     type: 'checkbox',
    //     props: {
    //         label: 'Factura exenta',
    //     },
    // },
    // {
    //     name: 'payable',
    //     type: 'checkbox',
    //     props: {
    //         falseValue: true,
    //         label: 'Bloquear pago',
    //         trueValue: false,
    //     },
    // },
    {
        name: 'selected_net_subtotal',
        type: 'currency-field',
        props: {
            label: 'Neto',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'selected_global_discount_amount',
        type: 'text-field',
        props: {
            label: 'Descuento %',
            reverse: true,
            readonly: true,
        },
        flex: {
            'offset-xs6': true,
            sm3: true,
        },
    },
    // {
    //     name: 'selected_new_net_subtotal',
    //     type: 'currency-field',
    //     props: {
    //         label: 'Subtotal',
    //         readonly: true,
    //         reverse: true,
    //     },
    //     flex: {
    //         sm3: true,
    //     },
    // },
    {
        name: 'selected_iva',
        type: 'currency-field',
        props: {
            label: 'IVA',
            readonly: true,
            reverse: true,
        },
        flex: {
            
            sm3: true,
        },
    },
    {
        name: 'selected_total',
        type: 'currency-field',
        props: {
            label: 'Total',
            readonly: true,
            reverse: true,
        },
        flex: {
            'offset-xs6': true,
            sm3: true,
        },
    },
]
